export class CartError extends Error {
  constructor(message, status) {
    super(message)
    this.name = 'CartError'
    this.project = 'ticketshop'
    this.response = { status }
  }
}
